function SupportIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.75C11.3 22.75 10.59 22.48 10.06 21.95L8.35001 20.26C7.92001 19.84 7.35999 19.61 6.75999 19.61H6C3.93 19.61 2.25 17.94 2.25 15.89V4.97998C2.25 2.92998 3.93 1.26001 6 1.26001H18C20.07 1.26001 21.75 2.92998 21.75 4.97998V15.89C21.75 17.94 20.07 19.61 18 19.61H17.24C16.64 19.61 16.07 19.84 15.65 20.26L13.94 21.95C13.41 22.48 12.7 22.75 12 22.75ZM6 2.75C4.76 2.75 3.75 3.74997 3.75 4.96997V15.88C3.75 17.11 4.76 18.1 6 18.1H6.75999C7.75999 18.1 8.7 18.4899 9.41 19.1899L11.12 20.88C11.61 21.36 12.4 21.36 12.89 20.88L14.6 19.1899C15.31 18.4899 16.25 18.1 17.25 18.1H18C19.24 18.1 20.25 17.1 20.25 15.88V4.96997C20.25 3.73997 19.24 2.75 18 2.75H6Z"
        fill="#292D32"
        className="fill"
      />
      <path
        d="M10.3802 14.51H7.70023C7.26023 14.51 6.85023 14.2999 6.59023 13.9399C6.34023 13.5999 6.28022 13.18 6.40022 12.78C6.75022 11.71 7.61022 11.13 8.37022 10.61C9.17022 10.07 9.62022 9.73002 9.62022 9.15002C9.62022 8.63002 9.20022 8.20996 8.68022 8.20996C8.16022 8.20996 7.74023 8.63002 7.74023 9.15002C7.74023 9.56002 7.40023 9.90002 6.99023 9.90002C6.58023 9.90002 6.24023 9.56002 6.24023 9.15002C6.24023 7.81002 7.33022 6.70996 8.68022 6.70996C10.0302 6.70996 11.1202 7.80002 11.1202 9.15002C11.1202 10.56 10.0602 11.28 9.21024 11.86C8.68024 12.22 8.18022 12.56 7.93022 13.01H10.3702C10.7802 13.01 11.1202 13.35 11.1202 13.76C11.1202 14.17 10.7902 14.51 10.3802 14.51Z"
        fill="#292D32"
        className="fill"
      />
      <path
        d="M16.0399 14.5101C15.6299 14.5101 15.2899 14.1701 15.2899 13.7601V13.07H13.3299C13.3299 13.07 13.3299 13.07 13.3199 13.07C12.8299 13.07 12.3799 12.8101 12.1299 12.3901C11.8799 11.9601 11.8799 11.4301 12.1299 11.0101C12.8099 9.84007 13.5999 8.51003 14.3199 7.35003C14.6399 6.84003 15.2499 6.61008 15.8199 6.77008C16.3899 6.94008 16.7899 7.46012 16.7799 8.06012V11.58H16.9999C17.4099 11.58 17.7499 11.92 17.7499 12.33C17.7499 12.74 17.4099 13.08 16.9999 13.08H16.7899V13.7701C16.7899 14.1801 16.4599 14.5101 16.0399 14.5101ZM15.2899 8.64007C14.6999 9.60007 14.0899 10.63 13.5399 11.57H15.2899V8.64007Z"
        fill="#292D32"
        className="fill"
      />
    </svg>
  );
}

export default SupportIcon;
